import { SiteSelectionDropdownConfig } from "../models/site-entity.model";

export const singlesiteSelectionDropdownConfig: SiteSelectionDropdownConfig = {
    displayKey: 'siteName',
    groupedKey: 'orgName',
    valueKey: 'siteId',
    placeholder: 'Select Site',
    searchPlaceholder: 'Search for Organization/Site/Address',
    siteSelection: true,
    multiSelect: false,
};
